function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "out-link",
  transform: "translate(-430.285 -556.14)"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow-down",
  transform: "translate(436.978 567.526) rotate(-135)",
  opacity: 0.8
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M0,6.637V0",
  transform: "translate(2.665)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M5.331,0,2.666,2.677,0,0",
  transform: "translate(0 3.96)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_37",
  "data-name": "Ellipse 37",
  transform: "matrix(1, -0.017, 0.017, 1, 430.285, 556.386)",
  fill: "none",
  stroke: "#ccc",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.033,
  cy: 7.033,
  r: 7.033,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.033,
  cy: 7.033,
  r: 6.533,
  fill: "none"
})));

function SvgOutLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.309,
    height: 14.309,
    viewBox: "0 0 14.309 14.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutLink);
export default __webpack_public_path__ + "static/media/out-link.cbd81c67.svg";
export { ForwardRef as ReactComponent };